module.exports = __webpack_public_path__ + "media/images/knockoutbet__sample@2x-20b30cfd3361c7238f5d0cfd6747902c.png";